<template>
    <el-carousel :interval="5000" height="672px" autoplay>
        <el-carousel-item v-for="item in getdataImg" :key="item.id">
            <el-image style="max-width:100%;max-height:100%" :src="item.img" fit="cover"></el-image>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
    data() {
        return {
            getdataImg: [],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            const { data: res } = await this.$ajax.post("/v1/banner/index", {
                position: 2,
            });
            if (res.code == 0) {
                this.getdataImg = res.data;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.el-carousel el-carousel--horizontal {
    width: 100%;
}
img {
    width: 100%;
    height: 100%;
    border-radius: 2px;
}
</style>
